import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const IconButton = ({ icon: Icon, onClick, disabled, className }) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    className={`icon-button ${className || ''}`}
  >
    <Icon />
  </button>
)

IconButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

IconButton.defaultProps = {
  disabled: false,
  className: ''
}

export default IconButton
